import Tick from "@pqina/tick";

console.log('[bundle] loaded');
window.addEventListener('error', (e) => console.log('[window.error]', e.message, e.error));
window.addEventListener('unhandledrejection', (e) => console.log('[promise.error]', e.reason));

window.startWeddingCountdown = function (tick) {
  const target = "2026-05-16T15:00:00-05:00"; // May 16, 2026 3:00 PM America/Chicago (CDT)
  const counter = Tick.count.down(target, { format: ["d", "h", "m", "s"], interval: 1000 });

  const pad2 = (n) => String(n).padStart(2, "0");

  counter.onupdate = ([d, h, m, s]) => {
    tick.value = `${d}d ${pad2(h)}:${pad2(m)}:${pad2(s)}`;
  };

  counter.onended = () => {
    tick.value = "0d 00:00:00";
  };
};

// This makes Tick “pick up” .tick elements in the page
document.addEventListener("DOMContentLoaded", () => {
  Tick.DOM.parse(document.body);
});

document.getElementById("rsvpFab")?.addEventListener("click", (e) => {
  e.preventDefault();

  const target = document.querySelector("#rsvp");
  if (!target) return;

  const startY = window.scrollY;
  const endY = target.getBoundingClientRect().top + window.scrollY;

  const durationMs = 900;
  const startT = performance.now();

  const easeInOutCubic = (t) =>
    t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

  const step = (now) => {
    const t = Math.min(1, (now - startT) / durationMs);
    const eased = easeInOutCubic(t);
    window.scrollTo(0, startY + (endY - startY) * eased);
    if (t < 1) requestAnimationFrame(step);
  };

  requestAnimationFrame(step);
  history.replaceState(null, "", "#rsvp");
});

// i18n.js
const I18N = (() => {
  const state = {
    lang: 'en',
    dicts: Object.create(null),
  };

  const LANG_FILES = {
    en: 'data/en.json',
    es: 'data/es.json',
    ko: 'data/ko.json',
  };

  function getByPath(obj, path) {
    return path.split('.').reduce((acc, key) => (acc && key in acc ? acc[key] : undefined), obj);
  }

  async function loadLang(lang) {
    if (state.dicts[lang]) return state.dicts[lang];
    const url = LANG_FILES[lang];
    if (!url) throw new Error(`Unknown language: ${lang}`);
    const res = await fetch(url, { cache: 'no-store' });
    if (!res.ok) throw new Error(`Failed to load ${url}: ${res.status}`);
    const json = await res.json();
    state.dicts[lang] = json;
    return json;
  }

  // Replace your apply() with this (keeps textContent by default, but supports <br> safely).
  function apply(dict) {
    document.querySelectorAll('[data-i18n]').forEach((el) => {
      const key = el.getAttribute('data-i18n');
      const val = getByPath(dict, key);
      if (typeof val !== 'string') return;

      // Only allow <br> tags. Everything else becomes text.
      const hasBr = /<\s*br\s*\/?\s*>/i.test(val);

      if (!hasBr) {
        el.textContent = val;
        return;
      }

      // Build a safe fragment: split on <br>, insert real <br> nodes.
      el.textContent = '';
      const parts = val.split(/<\s*br\s*\/?\s*>/i);

      parts.forEach((part, i) => {
        if (i > 0) el.appendChild(document.createElement('br'));
        el.appendChild(document.createTextNode(part));
      });
    });
  }


  async function setLang(lang) {
    const dict = await loadLang(lang);
    state.lang = lang;
    document.documentElement.setAttribute('lang', lang);
    localStorage.setItem('lang', lang);
    apply(dict);
  }

  function init() {
    const saved = localStorage.getItem('lang');
    const initial = saved && LANG_FILES[saved] ? saved : 'en';

    document.addEventListener('click', (e) => {
      const a = e.target.closest('[data-lang]');
      if (!a) return;
      e.preventDefault();
      setLang(a.getAttribute('data-lang'));
    });

    setLang(initial);
  }

  return { init, setLang };
})();

document.addEventListener('DOMContentLoaded', I18N.init);

document.addEventListener("DOMContentLoaded", () => {
  const audio = document.getElementById("bgm");
  const btn = document.getElementById("bgmToggle");
  if (!audio || !btn) return;

  const saved = localStorage.getItem("bgm") || "off";
  audio.volume = 0.18;

  const setLabel = () => (btn.textContent = audio.paused ? "Play Music" : "Pause Music");

  if (saved === "on") {
    audio.play().catch(() => {});
  }
  setLabel();

  btn.addEventListener("click", async () => {
    if (audio.paused) {
      try {
        await audio.play();
        localStorage.setItem("bgm", "on");
      } catch (e) {}
    } else {
      audio.pause();
      localStorage.setItem("bgm", "off");
    }
    setLabel();
  });
});
